import { KEY_HIDE_MODAL_CONFIRM_REMOVE_FROM_FAVORITES } from '../constants/localStorage';

export const getConfirmText = (entityTypeText: string) => {
  const suffixText = entityTypeText ? ` из раздела "${entityTypeText}"` : '';

  return `Вы действительно хотите удалить все избранные объекты${suffixText}?`;
};

let isHideModal = false;

export const isHideModalConfirmRemoveFromFavorites = () => {
  return isHideModal || Boolean(window.localStorage.getItem(KEY_HIDE_MODAL_CONFIRM_REMOVE_FROM_FAVORITES));
};

export const doNotShowModalRemoveFromFavorites = () => {
  isHideModal = true;

  return window.localStorage.setItem(KEY_HIDE_MODAL_CONFIRM_REMOVE_FROM_FAVORITES, '1');
};
